export default{
  // "logo_jp":window.IMGURL + "/newNavIcon/new_logo_jp.svg",
  "logo":window.IMGURL + "/newNavIcon/logo2025.svg",
  // 计价相关图片
  "quote_pcb":window.IMGURL + "/quote/quote-pcb.jpg",
  "quote_smt":window.IMGURL + "/quote/quote-assembly.jpg",
  "quote_smd":window.IMGURL + "/quote/quote-stencil.jpg",
  "quote_fpc":window.IMGURL + "/quote/quote-fpc.jpg",
  "quote_rfpc":window.IMGURL + "/quote/quote-rfpc.jpg",
  "quote_sale":window.IMGURL + "/quote/quote-sale.jpg",
  "quote_bom":window.IMGURL + "/quote/quote_bom.png",
  "quote_hqonline":window.IMGURL + "/quote/quote-hqonline.png",
  "quote_layout":window.IMGURL + "/quote/quote_layout.png",
  "quote_fpc_case1":window.IMGURL + "/quote/quote-case1.jpg",
  "quote_smt_tip1":window.IMGURL + "/quote/pcbaTip1.png",
  "quote_smt_tip2":window.IMGURL + "/quote/pcbaTip2.png",
  "quote_smt_tip3":window.IMGURL + "/quote/pcbaTip3.png",
  "quote_smd_tip1":window.IMGURL + "/quote/stencilTip1.png",
  "quote_size_display":window.IMGURL + "/quote/quote-case1_20220531.png",
  "quote_coupon":window.IMGURL + "/quote/coupon.png",
  "loading_0":window.IMGURL + "/loading-0.gif",
  // 底部图片
  "foot_flag1":window.IMGURL + "/img30/foot-payment.png",
  "foot_flag2":window.IMGURL + "/img30/foot-flagimg2.png",
  "foot_flag3":window.IMGURL + "/img30/foot-flagimg3.png",
  "foot_tubiao1":window.IMGURL + "/newNavIcon/tubiao1.png",
  "foot_tubiao2":window.IMGURL + "/newNavIcon/tubiao2.png",
  "foot_tubiao3":window.IMGURL + "/newNavIcon/tubiao3.png",
  "foot_tubiao4":window.IMGURL + "/newNavIcon/tubiao4.png",
  "foot_tubiao5":window.IMGURL + "/newNavIcon/tubiao5.png",
  // "foot_logo":window.IMGURL + "/img30/footer-logo.png",
  // "foot_logo":window.IMGURL + "/img30/foot-dfm-logo.png",
  "foot_nextpcb_logo":window.IMGURL + "/newNavIcon/logo2025_w.webp",
  "foot_hqonline_logo":window.IMGURL + "/img30/hqonline-white.svg",
  "foot_hqdfm_logo":window.IMGURL + "/img30/hqdfm-white-new.svg",
  "contact_us":window.IMGURL + "/common/icons/contact.svg",
  guide:{
    pcba:{
      'step1-1':window.IMGURL+'/guide/pcba/step1-1.png',
      'step1-2':window.IMGURL+'/guide/pcba/step1-2.png',
      'step1-3':window.IMGURL+'/guide/pcba/step1-3.png',
      'step1-arrow1':window.IMGURL+'/guide/pcba/step1-arrow1.svg',
      'step1-arrow2':window.IMGURL+'/guide/pcba/step1-arrow2.svg',
      'step2-1':window.IMGURL+'/guide/pcba/step2-1.png',
      'step2-2':window.IMGURL+'/guide/pcba/step2-2.png',
      'step2-arrow1':window.IMGURL+'/guide/pcba/step2-arrow1.svg',
      'step2-arrow2':window.IMGURL+'/guide/pcba/step2-arrow2.svg',
      'step3-1':window.IMGURL+'/guide/pcba/step3-1.png',
      'step3-2':window.IMGURL+'/guide/pcba/step3-2.png',
      'step3-arrow1':window.IMGURL+'/guide/pcba/step3-arrow1.svg',
      'step3-arrow2':window.IMGURL+'/guide/pcba/step3-arrow2.svg',
      'step4-1':window.IMGURL+'/guide/pcba/step4-1.png',
      'step4-2':window.IMGURL+'/guide/pcba/step4-2.png',
      'step4-arrow':window.IMGURL+'/guide/pcba/step4-arrow.svg',
      'step5-1':window.IMGURL+'/guide/pcba/step5-1.png',
      'step5-arrow':window.IMGURL+'/guide/pcba/step5-arrow.svg'
    }
  },
  not_match_all:window.IMGURL+'/not-match-all.svg',
  icon_plus: window.IMGURL + '/img30/icon/icon-plus.png',
  icon_minus: window.IMGURL + '/img30/icon/icon-minus.png',
  pb1_img: window.IMGURL + "/quote/pb1.png",
  pb2_img: window.IMGURL + "/quote/pb2.png",
  pb3_img: window.IMGURL + "/quote/pb3.png",
  pb4_img: window.IMGURL + "/quote/pb4.png",
  pb5_img: window.IMGURL + "/quote/pb5.png",
  pb6_img: window.IMGURL + "/quote/pb6.png",
  step_arrow: window.IMGURL + "/quote/step-arrow.png",
  step_arrow_h: window.IMGURL + "/quote/step-arrow-h.png",
  arrow_down: window.IMGURL + "/quote/arrow-down.png",
  'plate_type_fr-4': window.IMGURL + "/quote/plate_type_fr-4.webp",
  'plate_type_aluminum': window.IMGURL + "/quote/plate_type_aluminum.webp",
  'plate_type_copper': window.IMGURL + "/quote/plate_type_copper.webp",
  'plate_type_fpc': window.IMGURL + "/quote/quote-fpc.jpg",
  'plate_type_rfpc': window.IMGURL + "/quote/quote-rfpc.jpg",
  'plate_type_rogers': window.IMGURL + "/quote/plate_type_fr-4.webp",
  'plate_type_pcb': window.IMGURL + "/quote/quote-pcb.jpg",
  'plate_type_pcb_high': window.IMGURL + "/quote/quote-pcb-high.webp",
}